// Whether the Quality door is rendering for a READ-ONLY viewer (kanban
// 808dabf6). The triage shell provides it once from the signed-in user
// (`<QualityReadOnlyContext.Provider value={readOnly}>`); every write control
// inside the door (decision bars, asks, nudges, case-file edits, seen-marks)
// asks `useQualityReadOnly()` and stays out of the DOM for a viewer. The
// backend refuses the same writes (403), so this is the UX layer, not the
// guard. Default false: a component rendered outside the shell is writable.

import { createContext, useContext } from 'react';

export const QualityReadOnlyContext = createContext<boolean>(false);

/** True inside a read-only (viewer) render of the Quality door; false elsewhere. */
export function useQualityReadOnly(): boolean {
  return useContext(QualityReadOnlyContext);
}
